var _;
((e) => {
  ((r) => {
    r[r.House = 8] = "House", r[r.Year = 5] = "Year";
  })(e.GroupByEnum || (e.GroupByEnum = {})), ((r) => {
    r[r.All = 0] = "All", r[r.Current_Year = 1] = "Current_Year", r[r.Previous_Year = 9] = "Previous_Year", r[r.Current_Term = 3] = "Current_Term", r[r.Previous_Term = 7] = "Previous_Term", r[r.Current_Report_Period = 2] = "Current_Report_Period", r[r.Previous_Report_Period = 8] = "Previous_Report_Period";
  })(e.IntervalEnum || (e.IntervalEnum = {}));
})(_ || (_ = {}));
export {
  _ as points
};
//# sourceMappingURL=index.js.map
